import { render, staticRenderFns } from "./ccle.vue?vue&type=template&id=2852f75c&scoped=true&"
import script from "./ccle.vue?vue&type=script&lang=js&"
export * from "./ccle.vue?vue&type=script&lang=js&"
import style0 from "./ccle.vue?vue&type=style&index=0&id=2852f75c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2852f75c",
  null
  
)

export default component.exports